'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = canUseDOM;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/web-common/dist/canUseDOM.js
// module id = 740
// module chunks = 10